var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetDecor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1074,
    height: 940,
    viewBox: "0 0 1074 940",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_63_806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.121 618.258C394.121 729.677 332.757 820 257.061 820C181.364 820 120 729.677 120 618.258C120 506.84 181.364 416.517 257.061 416.517C332.757 416.517 394.121 506.84 394.121 618.258Z",
    fill: "url(#paint0_linear_63_806)",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954 321.742C954 433.16 892.636 523.483 816.939 523.483C741.243 523.483 679.879 433.16 679.879 321.742C679.879 210.323 741.243 120 816.939 120C892.636 120 954 210.323 954 321.742Z",
    fill: "url(#paint1_linear_63_806)",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.656 198.063C579.593 442.876 492.431 489.038 286.985 421.384L365.344 741.937C494.408 497.124 581.569 450.962 787.015 518.616L708.656 198.063Z",
    fill: "url(#paint2_linear_63_806)",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_63_806",
    x: 0,
    y: 0,
    width: 1074,
    height: 940,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_63_806"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_806",
    x1: 519.765,
    y1: 225.267,
    x2: 685.744,
    y2: 633.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2036FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DDF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_806",
    x1: 519.765,
    y1: 225.267,
    x2: 685.744,
    y2: 633.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2036FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DDF54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_806",
    x1: 519.765,
    y1: 225.267,
    x2: 685.744,
    y2: 633.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2036FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DDF54"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetDecor);
export default __webpack_public_path__ + "static/media/net-decor.a6d9d03ea46dc09677149b26c2abeece.svg";
export { ForwardRef as ReactComponent };